import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m31.986 21.618 6.697-6.62c.962-.952-.482-2.379-1.444-1.427l-6.696 6.62-8.939-8.837L28.3 4.741c.962-.95-.48-2.379-1.443-1.428L20.16 9.927l-3.48-3.44c-.963-.952-2.406.475-1.444 1.426L16.5 9.162l-4.422 4.36a9.653 9.653 0 0 0-.001 13.757l.057.057c-4.487 4.69-4.274 13.99 1.417 17.506a1.056 1.056 0 0 0 1.445-.33 1.03 1.03 0 0 0-.334-1.428c-4.458-2.755-4.64-10.468-1.044-14.281l.815.806a9.902 9.902 0 0 0 6.962 2.851 9.902 9.902 0 0 0 6.962-2.851l4.416-4.36 1.25 1.236c.963.951 2.407-.476 1.444-1.427l-3.48-3.44Z",
    fill: "currentColor"
  }));
};

var SvgPlug = styled(SvgComponent).withConfig({
  displayName: "Plug__SvgPlug",
  componentId: "sc-1p8f80w-0"
})(["", " ", ""], size, color);
export default SvgPlug;